import { useState, useEffect } from 'react';
import "./TagDeleteModal.css";
import Modal from "../shared/Modal";

type TagDeleteModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

export const TagDeleteModal = ({isOpen, onClose, onSubmit}: TagDeleteModalProps) => {

    // console.log("[FormDeleteModal] isOpen: ", isOpen);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="tag-delete-container">

                <div className="modal-title">
                    Delete Tag
                </div>
                
                Are you sure you want to delete this tag? It will be removed from any forms associated with it (don't worry, the forms will not be deleted).

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    > 
                        Cancel
                    </button>

                    <button 
                        className="button-save"
                        onClick={onSubmit}
                    > 
                        Delete
                    </button>
                </div>
                
            </div>
      </Modal>
    )
}